import { observer } from 'mobx-react-lite'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { JobCount } from '@/features/jobs/list/components/JobManagement/JobsViewer'

export interface JobCountContainerProps {
  vm: JobManagementViewModel
}

export const JobCountContainer = observer(function JobCountContainer({
  vm,
}: JobCountContainerProps) {
  return (
    <JobCount
      canViewArchived={vm.selectionVm.canViewArchivedJobs}
      label={vm.jobViewingActionsLabel}
      totalJobs={vm.searcher.totalJobs}
      onViewActive={vm.viewOnlyActiveJobs}
      onViewArchived={vm.viewOnlyArchivedJobs}
    />
  )
})
